import Vue from 'vue'
import { Component, Inject, Model, Prop, Watch } from 'vue-property-decorator'
import { InputRow } from "../models";
import FormImage from "./FormImage";
import FormEditor from "./FormEditor";
import FormInlineList from "./FormInlineList";
import { genUniqueId } from "../utils";

@Component({
  name: 'FormRows',
  components: { FormImage, FormEditor, FormInlineList }
})
export default class FormRows extends Vue {
  @Prop() inputs: InputRow[]

  @Prop() model: any

  @Prop({default: false}) nested: boolean

  rnd = genUniqueId()

  private _clipboard: any

  @Watch('model', {deep: false})
  modelChanged(newValue, oldValue) {
    if (newValue !== oldValue) {
      this.rnd = genUniqueId()
    }
  }

  @Watch('inputs')
  inputsChanged() {
    this.rnd = genUniqueId()
  }
}
Vue.component('FormRows', FormRows)
